import React, { useEffect } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import { useChatbot } from 'Contexts/ChatbotContext';
import "./Chatbot.css";
import Panel from 'Components/Panel/Panel';
import ChatbotIcon from "../../Components/SideBar/assets/icons/Chatbot.png";

const Chatbot = () => {
  const {
    messages,
    setMessages,
    userInput,
    setUserInput,
    messagesEndRef,
    setIsModalOpen
  } = useChatbot();

  useEffect(() => {
    document.title = "Redech | Chatbot";
    setIsModalOpen(false);
  }, []);
  
  useEffect(() => {
    if (messagesEndRef?.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    const formatted = userInput.charAt(0).toUpperCase() + userInput.slice(1);
    setUserInput('');
    setMessages(prev => [...prev, { role: 'user', content: formatted }]);

    try {
      const text = await ExecuteAxios.api('post', `/chat/send/`, { userMessage: formatted }, false);
      setMessages(prev => [...prev, { role: 'Redech', content: text }]);
    } catch (error) {
      console.error('Erro ao enviar a mensagem:', error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendMessage();
  };

  return (
    <LayoutDefault>
      <Panel style={{ width: '100%', display: 'flex', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 20px 8px inset' }}>
        <Panel style={{
          width: '96%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          margin: '4%',
          borderRadius: '10px'
        }}>
          <div className="chatbot-messages" style={{ marginBottom: '20px' }}>
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${msg.role === 'user' ? 'user-message' : 'bot-message'}`}
              >
                {msg.role === 'Redech' && <img src={ChatbotIcon} alt="Bot" className="bot-icon" />}
                {msg.content}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          <div className="chatbot-input">
            <input
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Digite sua pergunta..."
            />
            <button onClick={handleSendMessage}>Enviar</button>
          </div>
        </Panel>
      </Panel>
    </LayoutDefault>
  );
};

export default Chatbot;
